
import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import useTranslation from '../../../Hooks/UseTranslation'

import NotificationsDialog from '../../../Components/NotificationsDialog/NotificationsDialog'

const ToggleNotifications = () => {

  const { t } = useTranslation()

  const notifications = useSelector((state: any) => state.NotificationsReducer.result)

  const [ showNotifications, setShowNotifications ] = useState(false)

  const notRead = useMemo(() => {

    if (!notifications) {

      return 0
    }

    return notifications.filter((notification: any) => notification.status === 'not_read').length
  }, [])

  return (
    <>
      <div
        className="right-dropdown svg-icon-menu cursor-pointer"
        onClick={() => setShowNotifications(true)}
      >

        <div className="svg-icon-container">

          {!notRead ? null : (
            <span
              className="badge badge-primary"
            >
              {notRead}
            </span>
          )}
          <i className="far fa-bell"></i>
        </div>
      </div>

      <NotificationsDialog
        show={showNotifications}
        title={t('NOTIFICATIONS:Title')}
        notifications={notifications}
        onHide={() => setShowNotifications(false)}
      />
    </>
  )
}

export default ToggleNotifications
